import React from 'react';
import styles from '../StoreGuide.module.scss';
import SupportEmailLink from '../../../components/SupportEmailLink/SupportEmailLink';
import DiscordInviteButton from '../../../components/DiscordInviteButton/DiscordInviteButton';

const RiotGamesGuide: React.FC = () => {
  return (
    <div className={styles.guideContent}>
      <div className={styles.guideHeader}>
        <img 
          src={`${process.env.PUBLIC_URL}/images/logos/riot-games-logo.svg`}
          alt="Riot Games"
          className={styles.storeLogo}
          onError={(e) => {
            const target = e.currentTarget;
            target.onerror = null;
            target.style.display = 'none';
          }}
        />
        <div className={styles.storeTitle}>
          <h1>Riot Games – Valorant Gift Card Activation</h1>
          <p>Learn how to redeem Valorant Gift Cards through the Valorant Launcher</p>
        </div>
      </div>

      <div className={styles.stepsContainer}>
        <h2 className={styles.stepsTitle}>Step-by-Step Instructions</h2>
        <div className={styles.steps}>
          
          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>1</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Open Valorant Launcher</h3>
              <div className={styles.stepDescription}>
                Open your <strong className={styles.boldText}>Valorant Launcher</strong> and click on the <strong className={styles.boldText}>Valorant symbol</strong> located in the upper-right corner.
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>2</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Select Payment Method</h3>
              <div className={styles.stepDescription}>
                Click on the <strong className={styles.boldText}>Prepaid Cards and Codes</strong> option as the payment method.
              </div>
              <div className={styles.stepImage}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/activation-guides/valorant-step-2.png`}
                  alt="Step 2: Select Prepaid Cards and Codes"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>3</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Enter Activation Code</h3>
              <div className={styles.stepDescription}>
                Enter your activation code and fill up the necessary information.
              </div>
              <div className={styles.stepImage}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/activation-guides/valorant-step-3.png`}
                  alt="Step 3: Enter activation code"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>4</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Complete Activation</h3>
              <div className={styles.stepDescription}>
                Click <strong className={styles.boldText}>submit</strong> and enjoy your Valorant experience.
              </div>
              <div className={styles.stepImage}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/activation-guides/valorant-step-4.png`}
                  alt="Step 4: Click submit"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                  }}
                />
              </div>
              <div className={styles.stepDescription}>
                (Check the region before redeeming a gift card because they'll only be applicable to those regions/countries.)
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>5</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>OnePlay Support</h3>
              <div className={styles.stepDescription}>
                <div style={{ marginBottom: '12px' }}>
                  For any assistance please contact us via email at <SupportEmailLink /> or join our Discord channel:
                </div>
                <DiscordInviteButton />
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* <div className={styles.additionalNotes}>
        <h3>Important Notes</h3>
        <ul>
          <li>Check the region before redeeming a gift card because they'll only be applicable to those regions/countries</li>
          <li>Gift cards are region-locked and must match your account region</li>
          <li>Valorant Points can only be used in Valorant</li>
        </ul>
      </div> */}

      {/* <div className={styles.support}>
        <h3>Need More Help?</h3>
        <p>
          If you encounter any issues during the activation process, visit the official{' '}
          <a 
            href="https://support.riotgames.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.supportLink}
          >
            Riot Games Support Center
          </a>
          {' '}for additional assistance.
        </p>
      </div> */}
    </div>
  );
};

export default RiotGamesGuide; 